export default __webpack_public_path__ + "static/media/640_dummy2016-yoga01-de.902f517f.png";